import {
  selectAudienceSorted,
  selectAudiencesPagination,
} from '@mm/state/selectors/messengerAdSelectors';
import Select from 'antd/es/select';
import React, { useEffect } from 'react';
import { useFetchAudiences } from '@mm/state/hooks/use-fetch-audiences';
import { useSelector } from 'react-redux';
import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import styles from './AudienceSimpleSelect.module.css';

export const AudienceSimpleSelect = ({
  onChange,
  selectedAudienceId,
  className,
  withFetch = true,
}: {
  onChange: (audienceId: number) => void;
  selectedAudienceId?: number;
  className?: string;
  withFetch?: boolean;
}) => {
  const pagination = useSelector(selectAudiencesPagination);
  const audiences = useSelector(selectAudienceSorted);
  const botId = useSelector(activeChatbotIdSelector);

  const { fetch, fetchMore, isFetching } = useFetchAudiences({
    skipBusy: true,
  });
  const { retrieveAudienceById } = useAudiencesCRUDActions();

  const handleChange = (audienceId: number) => {
    onChange(Number(audienceId));
  };

  const options = audiences.map(audience => ({
    value: audience.id,
    label: audience.name,
  }));

  const handleScroll = async e => {
    const { target } = e || {};
    if (
      target &&
      target.scrollTop + target.clientHeight === target.scrollHeight
    ) {
      if (pagination.isLastPage) return;
      await fetchMore();
    }
  };

  const setDefaultValue = async () => {
    if (selectedAudienceId) {
      await retrieveAudienceById(botId, selectedAudienceId, true);
    }
  };

  useEffect(() => {
    if (withFetch) {
      fetch(1, 50);
    }
    setDefaultValue();
  }, []);

  return (
    <Select
      className={className}
      defaultValue={selectedAudienceId}
      placeholder="Choose"
      loading={isFetching}
      onChange={handleChange}
      options={options}
      onPopupScroll={handleScroll}
      popupClassName={styles.popup}
    />
  );
};
